module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'zoom-in' && templateVars.config ?
				templateVars.config :
				{
	"contentClickable": false,
	"maxWidth": "1024px"
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/zoom-in/config.yaml
// module id = 151
// module chunks = 0